import React from 'react';
import { WorkplacePatientStatus } from '../../../../graphql/graphql';
import EArchivePatientsListWrapper from '../EArchivePatientsListWrapper/EArchivePatientsListWrapper';

const EArchiveArchivedPatientsList = () => {
	const defaultFilter = { status: WorkplacePatientStatus.Archived };
	const excludeFilterFields = { status: true };

	return (
		<EArchivePatientsListWrapper
			defaultFilter={defaultFilter}
			excludeFilterFields={excludeFilterFields}
		/>
	);
};

export default EArchiveArchivedPatientsList;
